export type SlashCommand = {
  id: string;
  label: string;
  hint: string;
  aliases: string[];
  /** When false, shown in the menu but not selectable. Defaults to true. */
  enabled?: boolean;
  /** Default composer text when nothing follows the slash. */
  seed?: string;
  /** Prefix applied when selecting this command (config agents). */
  lead?: string;
};

/** Expandable product slash menu for the supervisor composer. */
export const SLASH_COMMANDS: SlashCommand[] = [
  {
    id: "contract-review",
    label: "Contract Review",
    hint: "Review a contract",
    aliases: ["review"],
    enabled: true,
    seed: "Review this contract",
  },
  {
    id: "drafting",
    label: "Drafting",
    hint: "Draft a legal document",
    aliases: ["draft"],
    enabled: false,
    seed: "Help me draft a contract",
  },
  {
    id: "contract-types",
    label: "Contract Types",
    hint: "Manage contract types",
    aliases: [],
    enabled: false,
    lead: "Use the contract type agent. ",
  },
  {
    id: "custom-roles",
    label: "Custom Roles",
    hint: "Manage custom roles",
    aliases: [],
    enabled: false,
    lead: "Use the custom role agent. ",
  },
];

export type SlashCommandId = (typeof SLASH_COMMANDS)[number]["id"];

export function isSlashCommandEnabled(command: SlashCommand): boolean {
  return command.enabled !== false;
}

export function slashQuery(value: string): string | null {
  const match = value.match(/^\/(\S*)/);
  return match ? match[1].toLowerCase() : null;
}

export function commandMatches(command: SlashCommand, query: string): boolean {
  const haystack = [command.id, command.label.toLowerCase(), ...command.aliases];
  return haystack.some((value) => value.includes(query));
}

/** Text after a leading `/token` (used when a slash badge is selected). */
export function slashRest(value: string): string {
  return value.replace(/^\/\S*\s?/, "").trimStart();
}

export function applySlashCommand(id: SlashCommandId, value: string): string {
  const command = SLASH_COMMANDS.find((entry) => entry.id === id);
  const rest = slashRest(value);
  if (!command) return rest;
  if (command.lead) return `${command.lead}${rest}`.trimEnd();
  if (rest.length > 0) return rest;
  return command.seed ?? "";
}
